import React from 'react';
import { JobCardData } from '../../../apis/JobPortalService';
import mapPin from '../../../assets/images/icons/mapPin.svg';
import money from '../../../assets/images/icons/money.svg';
import time from '../../../assets/images/icons/time.svg';
import { PopupState } from '../jobportal';

interface JobCardProps {
	data: JobCardData;
	setJobDetailsPopup: (newState: PopupState) => void;
	setApplyPopup: (newState: PopupState) => void;
}

const JobCard = ({ data, setJobDetailsPopup, setApplyPopup }: JobCardProps) => {
	const {
		companyName,
		location,
		otherCodingSkills,
		ctcOffered,
		deadline,
		rolesOffered,
		selectionProcess,
		jobCardId,
		eligibility,
	} = data;

	const rolesOfferedString = rolesOffered.join(', ');
	const selectionProcessString = selectionProcess.join(' > ');
	const locationString = location.join(', ');

	const formatDate = (date: string) => {
		const newDate = new Date(date);
		const day = newDate.getDate();
		const month = newDate
			.toLocaleString('default', { month: 'long' })
			.substring(0, 3);
		const time = newDate.toLocaleTimeString([], {
			hour: '2-digit',
			minute: '2-digit',
		});

		return day + ' ' + month + ', ' + time;
	};

	return (
		<div className="job-card">
			<div className="header-area">
				<div className="company-overview">
					<h3>{companyName}</h3>
					{locationString && (
						<div>
							<p
								className={
									location.length > 1 ? 'custom-tooltip' : ''
								}
								data-tooltip={locationString}
							>
								<img src={mapPin} />
								{location.length > 1
									? location.length + ' Locations'
									: location[0]}
							</p>
							{ctcOffered && (
								<p>
									<img src={money} />
									{ctcOffered.toUpperCase()}
								</p>
							)}
						</div>
					)}
				</div>
				{deadline && (
					<div className="deadline">
						<p>
							<img src={time} />
							Apply Before:
						</p>
						<p>{formatDate(deadline)}</p>
					</div>
				)}
			</div>
			<div className="body-area">
				{rolesOffered && (
					<div
						className={
							'positions ' +
							(rolesOfferedString.length > 45
								? 'custom-tooltip'
								: '')
						}
						data-tooltip={rolesOfferedString}
					>
						<h4>OPEN POSITIONS</h4>
						<p>{rolesOfferedString}</p>
					</div>
				)}
				{otherCodingSkills && (
					<div className="skills">
						<h4>Preferred skills(Good to have)</h4>
						<p>
							{otherCodingSkills.map((skill, idx) => (
								<span key={idx}>{skill}</span>
							))}
						</p>
					</div>
				)}
				{selectionProcessString && (
					<div
						className={
							'process ' +
							(selectionProcessString.length > 45
								? 'custom-tooltip'
								: '')
						}
						data-tooltip={selectionProcessString}
					>
						<h4>Selection Process</h4>
						<p>{selectionProcessString}</p>
					</div>
				)}
			</div>
			<div className="footer-area">
				<button
					className="apply"
					onClick={() => {
						if (eligibility)
							setApplyPopup({
								isOpen: true,
								identifier: jobCardId,
							});
					}}
					disabled={!eligibility}
				>
					{eligibility && <>Apply now</>}
					{!eligibility && new Date(deadline) < new Date() && (
						<>Deadline Passed</>
					)}
					{!eligibility && new Date(deadline) > new Date() && (
						<>Not Eligible</>
					)}
				</button>
				<button
					className="details"
					onClick={() => {
						setJobDetailsPopup({
							isOpen: true,
							identifier: jobCardId + 'source:jobs',
						});
					}}
				>
					More details
				</button>
			</div>
		</div>
	);
};

export default JobCard;
